import {isNotStringOrEmptyString} from "@utils/string";
import {isAfter, isBefore, isMatch, isValid, parse} from "date-fns";
import {YES_NO_CHOICE_OPTIONS} from "@constants/dropdown-choices";

export function isValidEmail(email) {
    if (typeof email !== 'string') {
        return false; // Handle non-string inputs
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
}

export function isInLabelValueArray(value, array) {

    if(undefined === value || null === value) {
        return false;
    }

    if(!Array.isArray(array)) {
        return false;
    }

    return array?.map((item) => item.value).includes(value);
}

export function isInLabelValueArrayAsString(value, array, invalidList = []) {

    if(undefined === value || null === value) {
        return false;
    }

    if(isNotStringOrEmptyString(value)) {
        return false;
    }

    if(!Array.isArray(array)) {
        return false;
    }
    
    if(Array.isArray(invalidList) && invalidList.includes(value)) {
       return false;
    }

    return array?.map((item) => item.value).includes(value);
}

export function isInYesNoOptions(value, invalidList = []) {
   
   if(undefined === value || null === value) {
      return false;
   }
   
   if(isNotStringOrEmptyString(value)) {
      return false;
   }
   
   let array = YES_NO_CHOICE_OPTIONS;
   
   if(!Array.isArray(array)) {
      return false;
   }
   
   if(Array.isArray(invalidList) && invalidList.includes(value)) {
      return false;
   }
   
   return array?.map((item) => item.value).includes(value);
}

export function isEmptyString(value) {

    return isNotStringOrEmptyString(value);

}

export const isValidDateTimeString = (value, format = 'yyyy-MM-dd') => {
    if (isEmptyString(value)) {
        return false;
    }

    format = typeof format === 'string' ? format.trim() : 'yyyy-MM-dd';

    if (format === '') {
        format = 'yyyy-MM-dd';
    }

    return isMatch(value, format, {
        strict: true,
    });
}

export const isDateGreaterThanNow = (dateString, format = 'yyyy-MM-dd') => {
    if (!isValidDateTimeString(dateString, format)) {
        return false;
    }

    const parsedDate = parse(dateString, format, new Date());
    return isAfter(parsedDate, new Date());
};

export const isDateLessThanNow = (dateString, format = 'yyyy-MM-dd') => {
    if (!isValidDateTimeString(dateString, format)) {
        return false;
    }

    const parsedDate = parse(dateString, format, new Date());
    return isBefore(parsedDate, new Date());
};

export function isValidPositiveNumber(value, includeZero = false) {

    if("string" !== typeof value && "number" !== typeof value) {
        return false;
    }

    if(!!includeZero) {
        value = value.toString().trim();

        if('' === value) {
            return false;
        }
    }

    let number = Number(value);

    if(isNaN(number)) {
        return false;
    }

    return !!includeZero ? number >= 0 : number > 0;

}